import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { map, switchMap, catchError } from 'rxjs/operators';
import { from } from 'rxjs/internal/observable/from';
import * as mssoBypass from './msso-bypass.actions';

import { CONFIG } from '../../../config';
import * as login from '../auth/auth.actions';
import { HttpClient } from '@angular/common/http';
import { LoginResponse, LoginRequest } from '../auth/auth.models';
import { EMPTY, Observable, of } from 'rxjs';
import { isNullOrUndefined } from 'util';
import { Actions as ActionsCDK } from "atlas-cdk";
import { ToastService } from '../../shared/toaster_/toaster_.service';
@Injectable()
export class MssoBypassEffects {
  public mssoBypassLogin$ = createEffect(() => this.actions$.pipe(
    ofType<mssoBypass.MssoBypassLoginAction>(mssoBypass.ActionTypes.LOGIN),
    map(action => action.payload),
    switchMap(payload =>
      this.login(payload).pipe(
        switchMap((response: LoginResponse) => [
          new login.LoginSuccessAction(response)
        ]),
        catchError(error => {
          // from([
          //   new AddErrorToastAction(!isNullOrUndefined(error.error)
          //     && !isNullOrUndefined(error.error.message) ? error.error.message : error.message)
          // ])

          this._toasterService.launchAlertError(error.error != null && error.error.message != null ? error.error.message : error.message, ActionsCDK.error);
          return EMPTY;
        }
        )
      )
    )
  ));

  public constructor(
    private readonly actions$: Actions,
    private readonly http: HttpClient,
    private readonly _toasterService: ToastService
  ) {
  }

  private login(payload: LoginRequest): Observable<LoginResponse> {
    return this.http.post<LoginResponse>(`${CONFIG.API_URL}/users/login`, payload);
  }
}
